<template>
  <!-- 在這裡動態綁定 no-bg -->
  <div class="app-shell" :class="{ 'no-bg': route.path === '/purchase' }">
    <NavBar v-if="!route.meta.hideNav" />

    <!-- 同樣這裡也加上 no-bg -->
    <main class="app-main" :class="{ 'no-bg': route.path === '/purchase' }">
      <router-view />
    </main>

    <SiteFooter v-if="!route.meta.hideFooter" />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import NavBar from '@/components/NavBar.vue'
import SiteFooter from '@/components/SiteFooter.vue'

const route = useRoute()
</script>

<style>
html, body, #app {
  height: 100%;
}
</style>
